import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './common/AuthProvider';
import Layout from './common/Layout';
import Home from './common/Home';
import NeedHelpPage from './common/NeedHelp';
import LoginPage from './common/LoginPage';
import Profile from './common/Profile';
import ScrollToTop from './common/ScrollToTop';
import Option from './common/Option.jsx';
import Checkoutdetails from './check-out/Checkoutdetails.jsx';
import CheckoutPayment from './PaymentScreen/CheckoutPayment.jsx';
import CheckoutSuccess from './PaymentScreen/CheckoutSuccess.jsx';
import Welcome from './common/Welcome.jsx';
import BookingdetailsPage from './common/BookingdetailsPage.jsx';
import WalkReservation from './CHECK-IN/checkinoptions/Walk-Reser';
import ReservationOptions from './CHECK-IN/Reservation/ReservationOptions';
import QRScanner from './CHECK-IN/Reservation/QR-code/QRScanner';
import QRDetails from './CHECK-IN/Reservation/QR-code/QRDetails';
import SearchReservation from './CHECK-IN/Reservation/Facial-Recognition/SearchREservation';
import CreateUser from './CHECK-IN/Reservation/Facial-Recognition/CreateUser';
import Booking from './CHECK-IN/Reservation/Booking-Options/Booking';
import BookingDetails from './CHECK-IN/Reservation/QR-code/QRDetails';
import UpdateDetails from './CHECK-IN/Reservation/UpdateDetails/UpdateDetails';
import FormDetails from './CHECK-IN/Walk-In/FormDetails';
import SelectRoomType from './CHECK-IN/Walk-In/SelectRoomType';
import BookingSummary from './CHECK-IN/Walk-In/BookingSummary';
import Reservation from './CHECK-IN/ReservationTable/Reservation';
import Identity from './check-out/DateUpdate/Identity';
import RoomUpgrade from './CHECK-IN/Reservation/UpdateDetails/RoomUpgrade.jsx';
import ReservationSearch from './admin-hotel/ReservationSearch.jsx';
import PaymentMethods from './PaymentScreen/Paymentmethods.jsx';
import FillField from './PaymentScreen/FillField.jsx';
import ConfirmPayment from './PaymentScreen/ConfirmPayment.jsx';
import Otp from './PaymentScreen/Otp.jsx';
import NotSuccessful from './PaymentScreen/NotSuccessful.jsx';
import Cash from './PaymentScreen/Cash.jsx';
import CompletedProcess from './PaymentScreen/CompletedProcess.jsx';
import OrderMeal from './Amenities/OrderMeal.jsx';
import HouseKeeping from './Amenities/HouseKeeping.jsx';
import PaidAmmenities from './Amenities/Paid/PaidAmmenities.jsx';
import RoomService from './Amenities/RoomServices/RoomService.jsx';
import SearchPage from './CHECK-IN/Walk-In/SearchPage.jsx';
import RoomAssignmentScreen from './common/RoomAssignmentScreen';
import PaymentAmenties from './Amenities/Paid/PaymentAmenities.jsx';
import RoomPayment from './Amenities/RoomServices/RoomPayment.jsx';
import ReservationCash from './PaymentScreen/ReservationCash.jsx';
import AddRoomType from './common/AddRoomType.jsx';
import Food from './Amenities/Paid/Food.jsx';
import FoodSuccesful from './Amenities/Paid/FoodSuccesful.jsx';
import AmenityServices from './Amenities/Paid/AmenityServices.jsx';
import AccountBookingPayments from './common/AccountBookingPayment.jsx';
import RequestResetPage from './common/RequestResetPage';
import ResetPasswordPage from './common/ResetPasswordPage';
import SpecialRequest from './common/SpecialRequest';
import CheckinDetails from './CHECK-IN/Reservation/Booking-Options/CheckinDetails';
import BookingCheckIn from './CHECK-IN/Reservation/Booking-Options/BookingCheckIn';
import { GuestFeedback } from './PaymentScreen/GuestFeedback';
import EnhanceCheckinStay from './CHECK-IN/Walk-In/EnhanceCheckinStay';
import ProgressSteps from './CHECK-IN/Walk-In/ProgressSteps';
import ReviewsPage from './common/ReviewsPage.jsx';
import NotCorrectOtp from './common/NotCorrectOtp';
import ReservationSteps from './CHECK-IN/profileguest/ReservationSteps.jsx';
import ProfileGuestOptions from './CHECK-IN/profileguest/ProfileGuestOptions.jsx';
import DueForCheckIn from './common/DueForCheckIn';
import CheckoutOptions from './common/CheckoutOptions';
import EditRoomDetails from './CHECK-IN/profileguest/EditRoomDetails.jsx';
import EnhanceStayModify from './CHECK-IN/profileguest/EnhanceStayModify.jsx';
import ReservationSummary from './CHECK-IN/profileguest/ReservationSummary.jsx';
import ModificationSuccessful from './CHECK-IN/profileguest/ModificationSuccesful.jsx';
import { useEffect, useRef, useState } from 'react';
import CreateUserLater from './CHECK-IN/Reservation/Facial-Recognition/CreateUserLater';

// Loading spinner component
const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
);

// Inactivity Warning Modal Component
const InactivityWarning = ({ onStayLoggedIn, onLogout, timeLeft }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
      <div className="bg-white rounded-lg p-8 max-w-md mx-4 relative z-10 shadow-xl">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-4">
            <svg
              className="h-8 w-8 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h3 className="text-lg font-medium text-gray-900 mb-2">Session Timeout Warning</h3>

          <p className="text-sm text-gray-500 mb-2">
            You will be logged out in{' '}
            <span className="font-bold text-yellow-600">{timeLeft} seconds</span> due to inactivity.
          </p>

          <p className="text-sm text-gray-500 mb-6">Would you like to stay logged in?</p>

          <div className="flex space-x-3">
            <button
              onClick={onStayLoggedIn}
              className="flex-1 bg-black text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors"
            >
              Stay Logged In
            </button>
            {/* <button
              onClick={onLogout}
              className="flex-1 bg-black text-white px-4 py-2 rounded-md text-sm font-medium border border-gray-300 hover:bg-gray-50 transition-colors"
            >
              Logout Now
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    // Store intended location before redirect
    const from = window.location.pathname + window.location.search;
    localStorage.setItem('redirectPath', from);
    return <Navigate to="/" replace />;
  }

  return children;
};

// Public Route Component (for routes accessible without auth)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

// Create a separate component for the app content that uses useAuth
const AppContent = () => {
  const { isAuthenticated, logout } = useAuth();
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const timerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const countdownRef = useRef(null);

  // Inactivity logout logic
  useEffect(() => {
    if (!isAuthenticated) {
      setShowWarning(false);
      return;
    }

    const INACTIVITY_TIMEOUT = 120000; // 120 seconds
    // const INACTIVITY_TIMEOUT = 600000; // 10 minutes
    const WARNING_TIME = 30000; // Show warning 30 seconds before

    // Clear all timers
    const clearAllTimers = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };

    // Handle logout
    const handleLogout = async () => {
      clearAllTimers();
      setShowWarning(false);
      await logout();
      toast.info('You have been logged out due to inactivity');
      window.location.href = '/';
    };

    // Show warning and start countdown
    const showWarningAndCountdown = () => {
      setShowWarning(true);
      setTimeLeft(30);

      // Update countdown every second
      countdownRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            handleLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

    // Reset timer on user activity
    const resetTimer = () => {
      clearAllTimers();
      setShowWarning(false);

      // Set warning timer
      warningTimerRef.current = setTimeout(
        showWarningAndCountdown,
        INACTIVITY_TIMEOUT - WARNING_TIME
      );

      // Set logout timer
      timerRef.current = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
    };

    // Track user activity events
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Initial timer start
    resetTimer();

    // Cleanup
    return () => {
      clearAllTimers();
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [isAuthenticated, logout]);

  // Handle stay logged in
  const handleStayLoggedIn = () => {
    setShowWarning(false);
    if (countdownRef.current) clearInterval(countdownRef.current);

    // Trigger a fake activity event to reset timers
    const event = new Event('mousedown');
    window.dispatchEvent(event);
  };

  // Handle manual logout
  const handleManualLogout = async () => {
    setShowWarning(false);
    if (countdownRef.current) clearInterval(countdownRef.current);
    await logout();
    toast.info('You have been logged out');
    window.location.href = '/login';
  };

  return (
    <>
      <ScrollToTop />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {/* Inactivity Warning Modal */}
      {showWarning && (
        <InactivityWarning
          onStayLoggedIn={handleStayLoggedIn}
          onLogout={handleManualLogout}
          timeLeft={timeLeft}
        />
      )}

      <Routes>
        {/* Layout wraps all routes */}
        <Route path="/" element={<Layout />}>
          {/* Public routes */}
          <Route index element={<Home />} />
          <Route
            path="login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route path="request-reset" element={<RequestResetPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="need-help" element={<NeedHelpPage />} />
          <Route path="reviews" element={<ReviewsPage />} />
          <Route path="create-user" element={<CreateUser />} />
          <Route path="addroomtype" element={<AddRoomType />} />
          <Route path="notcorrectotps" element={<NotCorrectOtp />} />

          {/* Protected routes */}
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="bookings/:bookingId"
            element={
              <ProtectedRoute>
                <AccountBookingPayments />
              </ProtectedRoute>
            }
          />

          <Route
            path="create-user-later"
            element={
              <ProtectedRoute>
                <CreateUserLater />
              </ProtectedRoute>
            }
          />

          <Route
            path="options"
            element={
              <ProtectedRoute>
                <Option />
              </ProtectedRoute>
            }
          />

          <Route
            path="check-out-field"
            element={
              <ProtectedRoute>
                <Checkoutdetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="check-out-options"
            element={
              <ProtectedRoute>
                <CheckoutOptions />
              </ProtectedRoute>
            }
          />

          <Route
            path="due-for-checkin"
            element={
              <ProtectedRoute>
                <DueForCheckIn />
              </ProtectedRoute>
            }
          />

          <Route
            path="check-out-invoice"
            element={
              <ProtectedRoute>
                <CheckoutPayment />
              </ProtectedRoute>
            }
          />

          <Route
            path="checkout-payment-success"
            element={
              <ProtectedRoute>
                <CheckoutSuccess />
              </ProtectedRoute>
            }
          />

          <Route
            path="guest-feedback"
            element={
              <ProtectedRoute>
                <GuestFeedback />
              </ProtectedRoute>
            }
          />

          <Route
            path="booking"
            element={
              <ProtectedRoute>
                <BookingdetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="check-in/options"
            element={
              <ProtectedRoute>
                <WalkReservation />
              </ProtectedRoute>
            }
          />

          <Route
            path="room-assign"
            element={
              <ProtectedRoute>
                <RoomAssignmentScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options"
            element={
              <ProtectedRoute>
                <ReservationOptions />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/qr-code"
            element={
              <ProtectedRoute>
                <QRScanner />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/qr-code/qr-booking"
            element={
              <ProtectedRoute>
                <QRDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="searchreservation"
            element={
              <ProtectedRoute>
                <SearchReservation />
              </ProtectedRoute>
            }
          />

          <Route
            path="booking-checkin"
            element={
              <ProtectedRoute>
                <BookingCheckIn />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking"
            element={
              <ProtectedRoute>
                <Booking />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/welcome"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/bookingdetails"
            element={
              <ProtectedRoute>
                <BookingDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/update"
            element={
              <ProtectedRoute>
                <UpdateDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="walk-in/form"
            element={
              <ProtectedRoute>
                <FormDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="walk-in/roomtype"
            element={
              <ProtectedRoute>
                <SelectRoomType />
              </ProtectedRoute>
            }
          />

          <Route
            path="walk-in/booking-summary"
            element={
              <ProtectedRoute>
                <BookingSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation_options"
            element={
              <ProtectedRoute>
                <ReservationSteps />
              </ProtectedRoute>
            }
          />

          <Route
            path="profile_guest_options"
            element={
              <ProtectedRoute>
                <ProfileGuestOptions />
              </ProtectedRoute>
            }
          />

          <Route
            path="edit-reservation/update-roomdetails"
            element={
              <ProtectedRoute>
                <EditRoomDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="edit-reservation/update-enhancements"
            element={
              <ProtectedRoute>
                <EnhanceStayModify />
              </ProtectedRoute>
            }
          />

          <Route
            path="edit-reservation/update-reservation-summary"
            element={
              <ProtectedRoute>
                <ReservationSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="Progress-steps"
            element={
              <ProtectedRoute>
                <ProgressSteps />
              </ProtectedRoute>
            }
          />

          <Route
            path="walk-in/reservations"
            element={
              <ProtectedRoute>
                <Reservation />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/update-checkout-date"
            element={
              <ProtectedRoute>
                <Identity />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/update-room-type"
            element={
              <ProtectedRoute>
                <RoomUpgrade />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservationsearch"
            element={
              <ProtectedRoute>
                <ReservationSearch />
              </ProtectedRoute>
            }
          />

          <Route
            path="upi-payment"
            element={
              <ProtectedRoute>
                <PaymentMethods />
              </ProtectedRoute>
            }
          />

          <Route path="card-payment" element={<FillField />} />

          <Route
            path="confirmpayment"
            element={
              <ProtectedRoute>
                <ConfirmPayment />
              </ProtectedRoute>
            }
          />

          <Route
            path="otp"
            element={
              <ProtectedRoute>
                <Otp />
              </ProtectedRoute>
            }
          />

          <Route
            path="not-succesful"
            element={
              <ProtectedRoute>
                <NotSuccessful />
              </ProtectedRoute>
            }
          />

          <Route
            path="cash"
            element={
              <ProtectedRoute>
                <Cash />
              </ProtectedRoute>
            }
          />

          <Route
            path="enhance-checkin-stay"
            element={
              <ProtectedRoute>
                <EnhanceCheckinStay />
              </ProtectedRoute>
            }
          />

          <Route
            path="payment-succesful"
            element={
              <ProtectedRoute>
                <CompletedProcess />
              </ProtectedRoute>
            }
          />

          <Route
            path="modification-succesful"
            element={
              <ProtectedRoute>
                <ModificationSuccessful />
              </ProtectedRoute>
            }
          />

          <Route
            path="order-meal"
            element={
              <ProtectedRoute>
                <OrderMeal />
              </ProtectedRoute>
            }
          />

          <Route
            path="house-keeping"
            element={
              <ProtectedRoute>
                <HouseKeeping />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/welcome/paid-amenities"
            element={
              <ProtectedRoute>
                <AmenityServices />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/welcome/room-service"
            element={
              <ProtectedRoute>
                <RoomService />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/welcome/food-service"
            element={
              <ProtectedRoute>
                <Food />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation/options/booking/welcome/food-service/succesful"
            element={
              <ProtectedRoute>
                <FoodSuccesful />
              </ProtectedRoute>
            }
          />

          <Route
            path="reservation-succesful"
            element={
              <ProtectedRoute>
                <ReservationCash />
              </ProtectedRoute>
            }
          />

          <Route
            path="checkin-details"
            element={
              <ProtectedRoute>
                <CheckinDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="amenities-payment-succesful"
            element={
              <ProtectedRoute>
                <PaymentAmenties />
              </ProtectedRoute>
            }
          />

          <Route
            path="roomservice-payment-succesful"
            element={
              <ProtectedRoute>
                <RoomPayment />
              </ProtectedRoute>
            }
          />

          <Route
            path="walk-in/room-reservation"
            element={
              <ProtectedRoute>
                <SearchPage />
              </ProtectedRoute>
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
};

// Main App Component
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;

// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { AuthProvider, useAuth } from "./common/AuthProvider";
// import Layout from "./common/Layout";
// import Home from "./common/Home";
// import NeedHelpPage from "./common/NeedHelp";
// import LoginPage from "./common/LoginPage";
// import Profile from "./common/Profile";
// import ScrollToTop from "./common/ScrollToTop";
// import Option from "./common/Option.jsx";
// import Checkoutdetails from "./check-out/Checkoutdetails.jsx";
// import CheckoutPayment from "./PaymentScreen/CheckoutPayment.jsx";
// import CheckoutSuccess from "./PaymentScreen/CheckoutSuccess.jsx";
// import Welcome from "./common/Welcome.jsx";
// import BookingdetailsPage from "./common/BookingdetailsPage.jsx";
// import WalkReservation from "./CHECK-IN/checkinoptions/Walk-Reser";
// import ReservationOptions from "./CHECK-IN/Reservation/ReservationOptions";
// import QRScanner from "./CHECK-IN/Reservation/QR-code/QRScanner";
// import QRDetails from "./CHECK-IN/Reservation/QR-code/QRDetails";
// import SearchReservation from "./CHECK-IN/Reservation/Facial-Recognition/SearchREservation";
// import CreateUser from "./CHECK-IN/Reservation/Facial-Recognition/CreateUser";
// import Booking from "./CHECK-IN/Reservation/Booking-Options/Booking";
// import BookingDetails from "./CHECK-IN/Reservation/QR-code/QRDetails";
// import UpdateDetails from "./CHECK-IN/Reservation/UpdateDetails/UpdateDetails";
// import FormDetails from "./CHECK-IN/Walk-In/FormDetails";
// import SelectRoomType from "./CHECK-IN/Walk-In/SelectRoomType";
// import BookingSummary from "./CHECK-IN/Walk-In/BookingSummary";
// import Reservation from "./CHECK-IN/ReservationTable/Reservation";
// import Identity from "./check-out/DateUpdate/Identity";
// import RoomUpgrade from "./CHECK-IN/Reservation/UpdateDetails/RoomUpgrade.jsx";
// import ReservationSearch from "./admin-hotel/ReservationSearch.jsx";
// import PaymentMethods from "./PaymentScreen/Paymentmethods.jsx";
// import FillField from "./PaymentScreen/FillField.jsx";
// import ConfirmPayment from "./PaymentScreen/ConfirmPayment.jsx";
// import Otp from "./PaymentScreen/Otp.jsx";
// import NotSuccessful from "./PaymentScreen/NotSuccessful.jsx";
// import Cash from "./PaymentScreen/Cash.jsx";
// import CompletedProcess from "./PaymentScreen/CompletedProcess.jsx";
// import OrderMeal from "./Amenities/OrderMeal.jsx";
// import HouseKeeping from "./Amenities/HouseKeeping.jsx";
// import PaidAmmenities from "./Amenities/Paid/PaidAmmenities.jsx";
// import RoomService from "./Amenities/RoomServices/RoomService.jsx";
// import SearchPage from "./CHECK-IN/Walk-In/SearchPage.jsx";
// import RoomAssignmentScreen from "./common/RoomAssignmentScreen";
// import PaymentAmenties from "./Amenities/Paid/PaymentAmenities.jsx";
// import RoomPayment from "./Amenities/RoomServices/RoomPayment.jsx";
// import ReservationCash from "./PaymentScreen/ReservationCash.jsx";
// import AddRoomType from "./common/AddRoomType.jsx";
// import Food from "./Amenities/Paid/Food.jsx";
// import FoodSuccesful from "./Amenities/Paid/FoodSuccesful.jsx";
// import AmenityServices from "./Amenities/Paid/AmenityServices.jsx";
// import AccountBookingPayments from "./common/AccountBookingPayment.jsx";
// import RequestResetPage from "./common/RequestResetPage";
// import ResetPasswordPage from "./common/ResetPasswordPage";
// import SpecialRequest from "./common/SpecialRequest";
// import CheckinDetails from "./CHECK-IN/Reservation/Booking-Options/CheckinDetails";

// import BookingCheckIn from "./CHECK-IN/Reservation/Booking-Options/BookingCheckIn";

// import { GuestFeedback } from "./PaymentScreen/GuestFeedback";
// import EnhanceCheckinStay from "./CHECK-IN/Walk-In/EnhanceCheckinStay";
// import ProgressSteps from "./CHECK-IN/Walk-In/ProgressSteps";
// import ReviewsPage from "./common/ReviewsPage.jsx";
// import NotCorrectOtp from "./common/NotCorrectOtp";
// import ReservationSteps from "./CHECK-IN/profileguest/ReservationSteps.jsx";
// import ProfileGuestOptions from "./CHECK-IN/profileguest/ProfileGuestOptions.jsx";
// import DueForCheckIn from "./common/DueForCheckIn";
// import CheckoutOptions from "./common/CheckoutOptions";
// import EditRoomDetails from "./CHECK-IN/profileguest/EditRoomDetails.jsx";
// import EnhanceStayModify from "./CHECK-IN/profileguest/EnhanceStayModify.jsx";
// import ReservationSummary from "./CHECK-IN/profileguest/ReservationSummary.jsx";
// import ModificationSuccessful from "./CHECK-IN/profileguest/ModificationSuccesful.jsx";

// // Loading spinner component
// const LoadingSpinner = () => (
//   <div className="flex justify-center items-center h-screen">
//     <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//   </div>
// );

// // Protected Route Component
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, isLoading } = useAuth();

//   if (isLoading) {
//     return <LoadingSpinner />;
//   }

//   if (!isAuthenticated) {
//     // Store intended location before redirect
//     const from = window.location.pathname + window.location.search;
//     localStorage.setItem("redirectPath", from);
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// // Public Route Component (for routes accessible without auth)
// const PublicRoute = ({ children }) => {
//   const { isAuthenticated, isLoading } = useAuth();

//   if (isLoading) {
//     return <LoadingSpinner />;
//   }

//   return isAuthenticated ? <Navigate to="/" replace /> : children;
// };

// const App = () => {
//   return (
//     <Router>
//       <AuthProvider>
//         <ScrollToTop />
//         <ToastContainer
//           position="top-center"
//           autoClose={5000}
//           hideProgressBar
//           newestOnTop
//           closeOnClick
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//           theme="colored"
//         />

//         <Routes>
//           {/* Layout wraps all routes */}
//           <Route path="/" element={<Layout />}>
//             {/* Public routes */}
//             <Route index element={<Home />} />
//             <Route
//               path="login"
//               element={
//                 <PublicRoute>
//                   <LoginPage />
//                 </PublicRoute>
//               }
//             />
//             <Route path="request-reset" element={<RequestResetPage />} />
//             <Route path="reset-password" element={<ResetPasswordPage />} />
//             <Route path="need-help" element={<NeedHelpPage />} />
//             <Route path="reviews" element={<ReviewsPage />} />
//             <Route path="create-user" element={<CreateUser />} />
//             <Route path="addroomtype" element={<AddRoomType />} />
//             <Route path="notcorrectotps" element={<NotCorrectOtp />} />

//             {/* Protected routes */}
//             <Route
//               path="profile"
//               element={
//                 <ProtectedRoute>
//                   <Profile />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="bookings/:bookingId"
//               element={
//                 <ProtectedRoute>
//                   <AccountBookingPayments />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="options"
//               element={
//                 <ProtectedRoute>
//                   <Option />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Add all other protected routes in the same pattern */}

//             <Route
//               path="check-out-field"
//               element={
//                 <ProtectedRoute>
//                   <Checkoutdetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="check-out-options"
//               element={
//                 <ProtectedRoute>
//                   <CheckoutOptions />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="due-for-checkin"
//               element={
//                 <ProtectedRoute>
//                   <DueForCheckIn />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="check-out-invoice"
//               element={
//                 <ProtectedRoute>
//                   <CheckoutPayment />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="checkout-payment-success"
//               element={
//                 <ProtectedRoute>
//                   <CheckoutSuccess />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="guest-feedback"
//               element={
//                 <ProtectedRoute>
//                   <GuestFeedback />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="booking"
//               element={
//                 <ProtectedRoute>
//                   <BookingdetailsPage />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="check-in/options"
//               element={
//                 <ProtectedRoute>
//                   <WalkReservation />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="room-assign"
//               element={
//                 <ProtectedRoute>
//                   <RoomAssignmentScreen />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Continue with all other routes... */}
//             <Route
//               path="reservation/options"
//               element={
//                 <ProtectedRoute>
//                   <ReservationOptions />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/qr-code"
//               element={
//                 <ProtectedRoute>
//                   <QRScanner />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/qr-code/qr-booking"
//               element={
//                 <ProtectedRoute>
//                   <QRDetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="searchreservation"
//               element={
//                 <ProtectedRoute>
//                   <SearchReservation />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="booking-checkin"
//               element={
//                 <ProtectedRoute>
//                   <BookingCheckIn />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/booking"
//               element={
//                 <ProtectedRoute>
//                   <Booking />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/booking/welcome"
//               element={
//                 <ProtectedRoute>
//                   <Welcome />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/booking/bookingdetails"
//               element={
//                 <ProtectedRoute>
//                   <BookingDetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/booking/update"
//               element={
//                 <ProtectedRoute>
//                   <UpdateDetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="walk-in/form"
//               element={
//                 <ProtectedRoute>
//                   <FormDetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="walk-in/roomtype"
//               element={
//                 <ProtectedRoute>
//                   <SelectRoomType />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="walk-in/booking-summary"
//               element={
//                 <ProtectedRoute>
//                   <BookingSummary />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation_options"
//               element={
//                 <ProtectedRoute>
//                   {" "}
//                   <ReservationSteps />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="profile_guest_options"
//               element={
//                 <ProtectedRoute>
//                   <ProfileGuestOptions />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="edit-reservation/update-roomdetails"
//               element={
//                 <ProtectedRoute>
//                   <EditRoomDetails />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="edit-reservation/update-enhancements"
//               element={
//                 <ProtectedRoute>
//                   <EnhanceStayModify />
//                 </ProtectedRoute>
//               }
//             />
//              <Route
//               path="edit-reservation/update-reservation-summary"
//               element={
//                 <ProtectedRoute>
//                   <ReservationSummary />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="Progress-steps"
//               element={
//                 <ProtectedRoute>
//                   <ProgressSteps />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="walk-in/reservations"
//               element={
//                 <ProtectedRoute>
//                   <Reservation />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="reservation/options/update-checkout-date"
//               element={
//                 <ProtectedRoute>
//                   <Identity />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation/options/update-room-type"
//               element={
//                 <ProtectedRoute>
//                   {" "}
//                   <RoomUpgrade />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservationsearch"
//               element={
//                 <ProtectedRoute>
//                   <ReservationSearch />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="upi-payment"
//               element={
//                 <ProtectedRoute>
//                   <PaymentMethods />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route path="card-payment" element={<FillField />} />
//             <Route
//               path="confirmpayment"
//               element={
//                 <ProtectedRoute>
//                   {" "}
//                   <ConfirmPayment />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="otp"
//               element={
//                 <ProtectedRoute>
//                   {" "}
//                   <Otp />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="not-succesful"
//               element={
//                 <ProtectedRoute>
//                   <NotSuccessful />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="cash"
//               element={
//                 <ProtectedRoute>
//                   <Cash />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="enhance-checkin-stay"
//               element={
//                 <ProtectedRoute>
//                   <EnhanceCheckinStay />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="payment-succesful"
//               element={
//                 <ProtectedRoute>
//                   <CompletedProcess />{" "}
//                 </ProtectedRoute>
//               }
//             />
//              <Route
//               path="modification-succesful"
//               element={
//                 <ProtectedRoute>
//                   <ModificationSuccessful />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="order-meal"
//               element={
//                 <ProtectedRoute>
//                   <OrderMeal />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="house-keeping"
//               element={
//                 <ProtectedRoute>
//                   <HouseKeeping />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation/options/booking/welcome/paid-amenities"
//               element={
//                 <ProtectedRoute>
//                   <AmenityServices />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation/options/booking/welcome/room-service"
//               element={
//                 <ProtectedRoute>
//                   <RoomService />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation/options/booking/welcome/food-service"
//               element={
//                 <ProtectedRoute>
//                   <Food />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation/options/booking/welcome/food-service/succesful"
//               element={
//                 <ProtectedRoute>
//                   <FoodSuccesful />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="reservation-succesful"
//               element={
//                 <ProtectedRoute>
//                   <ReservationCash />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="checkin-details"
//               element={
//                 <ProtectedRoute>
//                   <CheckinDetails />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="amenities-payment-succesful"
//               element={
//                 <ProtectedRoute>
//                   <PaymentAmenties />{" "}
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="roomservice-payment-succesful"
//               element={
//                 <ProtectedRoute>
//                   <RoomPayment />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="walk-in/room-reservation"
//               element={
//                 <ProtectedRoute>
//                   <SearchPage />
//                 </ProtectedRoute>
//               }
//             />

//             {/* Catch-all route */}
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Route>
//         </Routes>
//       </AuthProvider>
//     </Router>
//   );
// };

// export default App;
